"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Typography = void 0;
Object.defineProperty(exports, "typographyVariantEnum", {
  enumerable: true,
  get: function () {
    return _interface.typographyVariantEnum;
  }
});
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _CustomTag = require("./components/CustomTag.js");
var _interface = require("./interface.js");
var _themeProvider = require("../../../theme/themeProvider/index.js");
require("./components/styles.css");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["children", "className", "variant", "color", "align", "noWrap", "gutterBottom", "maxWidth", "lineHeight", "onClickTypography", "boxShadow", "shadowType", "shadowBlurValue", "shadowColor", "textShadow", "letterSpacing", "textTransformation", "textDecoration", "wordSpacing", "isTypographyEditable", "onChangeTypography", "handleTooltip", "handleChangeTitle", "isEditInProgress"];
let CustomTagAs;
const getCustomTagAs = variant => {
  switch (variant) {
    case 'title1' || 'title2' || 'title3' || _interface.typographyVariantEnum.title:
      CustomTagAs = 'h1';
      break;
    case 'headline' || _interface.typographyVariantEnum.headline:
      CustomTagAs = 'h2';
      break;
    case 'subheadline' || _interface.typographyVariantEnum.subHeadLine:
      CustomTagAs = 'h3';
      break;
    default:
      CustomTagAs = 'span';
      break;
  }
};
const Typography = props => {
  const theme = (0, _themeProvider.useTheme)();
  const {
      children,
      className,
      variant = 'body',
      color = 'inherit',
      align = 'inherit',
      noWrap = false,
      gutterBottom = false,
      maxWidth = 'auto',
      lineHeight,
      onClickTypography,
      boxShadow,
      shadowType,
      shadowBlurValue,
      shadowColor,
      textShadow,
      letterSpacing,
      textTransformation,
      textDecoration,
      wordSpacing,
      isTypographyEditable = false,
      onChangeTypography,
      handleTooltip,
      handleChangeTitle,
      isEditInProgress = false
    } = props,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  let {
    as
  } = props;
  if (as === undefined) {
    getCustomTagAs(variant);
  }
  const typographyStyle = [`typography__${variant} typography__align-${align}`, className].join(' ');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomTag.CustomTag, Object.assign({
    as: CustomTagAs ?? 'span',
    className: typographyStyle,
    color: color,
    gutterBottom: gutterBottom,
    noWrap: noWrap,
    onClick: onClickTypography,
    variant: variant,
    theme: theme,
    maxWidth: maxWidth,
    lineHeight: lineHeight,
    boxShadow: boxShadow,
    shadowType: shadowType,
    shadowBlurValue: shadowBlurValue,
    shadowColor: shadowColor,
    textShadow: textShadow,
    letterSpacing: letterSpacing,
    textTransformation: textTransformation,
    textDecoration: textDecoration,
    wordSpacing: wordSpacing,
    contentEditable: isTypographyEditable,
    suppressContentEditableWarning: true,
    onBlur: e => onChangeTypography?.(e.currentTarget.textContent ?? ''),
    onMouseEnter: () => handleTooltip && handleTooltip(true),
    onMouseLeave: () => handleTooltip && handleTooltip(false),
    onInput: () => !isEditInProgress && handleChangeTitle?.()
  }, rest, {
    children: children
  }));
};
exports.Typography = Typography;
var _default = exports.default = Typography;